import {
  updateFilteredItemsAndSelectedKeysOnBlogFilterChipSelection,
  updateInitialStateWithFilterItemsAndKeys,
  updateStateOnSelectedSearch,
} from './stateUpdaters'
import { ActionTypes, defaultInvisibleItemsLength } from './actions'

function blogSimpleArticleListReducer(
  state,
  action /*{type: ActionTypes, payload: any}*/
) {
  const updatedState = { ...state }
  switch (action.type) {
    case ActionTypes.selectBlogFilter: {
      const newStateWithFilterSelection =
        updateFilteredItemsAndSelectedKeysOnBlogFilterChipSelection(
          updatedState,
          action
        )
      return { ...updatedState, ...newStateWithFilterSelection }
    }
    case ActionTypes.updateFiltersItemsAndKeysUpdate: {
      const newStateWithDefaultData = updateInitialStateWithFilterItemsAndKeys(
        updatedState,
        action
      )
      return { ...updatedState, ...newStateWithDefaultData }
    }
    case ActionTypes.clearBlogFilters: {
      const { items = [] } = state
      const itemsVisible =
        items.length >= defaultInvisibleItemsLength
          ? defaultInvisibleItemsLength
          : items.length
      return {
        ...updatedState,
        selectedKeys: [],
        filteredItems: [...items],
        itemsVisible,
        selectedSearch: '',
      }
    }
    case ActionTypes.updateParameters:
      return { ...updatedState, parameters: action.payload }
    case ActionTypes.updateItemsVisible: {
      const { itemsVisible: existingCountOfItemsVisible, filteredItems = [] } =
        state
      const newCountOfItemsVisible =
        existingCountOfItemsVisible + defaultInvisibleItemsLength >
        filteredItems.length
          ? filteredItems.length
          : existingCountOfItemsVisible + defaultInvisibleItemsLength
      return { ...updatedState, itemsVisible: newCountOfItemsVisible }
    }
    case ActionTypes.searchForPosts:
      return updateStateOnSelectedSearch(updatedState, action)
    default:
      return updatedState
  }
}
export { blogSimpleArticleListReducer }
